import React from 'react';
import PropTypes from 'prop-types';
import TagsInput from "react-tagsinput";
import {Field} from "formik";

// Core components
import Danger from "components/Typography/Danger.jsx";

// Styled Components
import DivMarginCenter from "../../components/styled-components/DivMarginCenter";

// Custom components
import SuggestionSearchAsync from "../../components/styled/SuggestionSearchAsync";

/*
* Custom field Autosuggest single
* Requires a list of suggestions for searching and automatically setting field value according to
* */
const FieldAutosuggestSingleAsync = ({
                                  name, hidden,
                                  suggestionList, getSuggestionName,
                                  getSuggestionId, placeholder, loadSuggestions,
                                  findSelectedSuggestionCustom,
                                  error
                                }) => {

  // local utils
  const findSelectedSuggestion = id => suggestionList ? suggestionList.find((segment) => {
    return segment._id === id;
  }) : [];

  const getTagsForFieldValue = (field) => {
    return !!field.value ? [getSuggestionName(
      findSelectedSuggestionCustom ?
        findSelectedSuggestionCustom(suggestionList, field.value) :
        findSelectedSuggestion(field.value))] : [];
  };

  return (
    <Field name={name}>
      {({field, form}) => {
        if (!hidden) {
          return (
            <DivMarginCenter>
              {
                field.value ?
                  <TagsInput
                    value={getTagsForFieldValue(field)}
                    onChange={(values) => {
                      // Clear field value when tags deleted
                      if (!values.length) {
                        form.setFieldValue(name, '');
                      }
                    }}
                    tagProps={{className: "react-tagsinput-tag info"}}
                    inputProps={{
                      type: 'hidden'
                    }}
                  /> : []
              }
              {/* ERROR */}
              {
                !error ? [] : <Danger>{error}</Danger>
              }
              {!field.value ?
                <SuggestionSearchAsync
                  suggestionList={suggestionList}
                  selected={(id) => {
                    form.setFieldValue(name, id);
                  }}
                  placeholder={placeholder}
                  getSuggestionName={getSuggestionName}
                  getSuggestionId={getSuggestionId}
                  loadSuggestions={loadSuggestions}
                /> : []
              }
            </DivMarginCenter>
          );
        }else {
          return [];
        }
      }}
    </Field>
  );
};

FieldAutosuggestSingleAsync.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  hidden: PropTypes.bool,
  suggestionList: PropTypes.array.isRequired,
  getSuggestionName: PropTypes.func.isRequired,
  loadSuggestions: PropTypes.func.isRequired,
  getSuggestionId: PropTypes.func.isRequired,
  findSelectedSuggestionCustom: PropTypes.func
};

export default FieldAutosuggestSingleAsync;
